/**
 * @file コンポーネント：検索キーワード絞り込み DOM管理
 */

// ライブラリ読み込み
import React from "react";

// スタイル読み込み
import { StyledForm, StyledFormButton, StyledFormInput } from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ReactDOM
    return (
        <StyledForm action={props.urlSearchAction} method="get">
            <StyledFormInput
                name="keyword"
                placeholder={props.placeholder}
                type="text"
            />
            <StyledFormButton type="submit">
                <i className="fas fa-search"></i>
            </StyledFormButton>
        </StyledForm>
    );
};
